import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';

type Props = {
  label: string;
  value: number;
  options: React.ReactNode[];
  onChange?: (event: SelectChangeEvent<number>) => void;
  disabled?: boolean;
  className?: string;
};

const AlarmActiveSelect = ({ label, value, options, onChange, disabled, className }: Props) => (
  <FormControl sx={{ minWidth: '100%' }}>
    <InputLabel id="alarm-active-label">{label}</InputLabel>
    <Select
      inputProps={{ 'data-testid': 'AlarmActiveInput' }}
      id="alarmActiveInput"
      variant="outlined"
      className={className}
      labelId="alarm-active-label"
      label={label}
      value={value}
      defaultValue={0}
      onChange={onChange}
      disabled={disabled}
    >
      {options.map((menuItem) => menuItem)}
    </Select>
  </FormControl>
);

export default AlarmActiveSelect;
